export const BG_STATUS_COLORS = {
  Aktif: '#E9FFF2',
  Dijadwalkan: '#E7F1FF',
  Nonaktif: '#FFF1F3',
};

export const TEXT_STATUS_COLORS = {
  Aktif: 'var(--color-success60)',
  Dijadwalkan: 'var(--color-primary70)',
  Nonaktif: 'var(--color-error60)',
};
